import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./translations/locales/en/translation.json";
import translationES from "./translations/locales/es/translation.json";
import translationFR from "./translations/locales/fr/translation.json";
import translationIT from "./translations/locales/it/translation.json";
import translationPT from "./translations/locales/pt/translation.json";
import translationAR from "./translations/locales/ar/translation.json";

import translationPL from "./translations/locales/pl/translation.json";
import translationRU from "./translations/locales/ru/translation.json";
import translationDE from "./translations/locales/de/translation.json";
import translationVI from "./translations/locales/vi/translation.json";
import translationZH from "./translations/locales/zh/translation.json";
import translationPH from "./translations/locales/ph/translation.json";
import translationJA from "./translations/locales/ja/translation.json";
import translationNL from "./translations/locales/nl/translation.json";
import translationHI from "./translations/locales/hi/translation.json";
import translationTR from "./translations/locales/tr/translation.json";
import translationTL from "./translations/locales/tl/translation.json";

let lang = "en";
if (window.location.pathname.match("/es/")) {
  localStorage.setItem("i18nextLng", "es");
  lang = "es";
} else if (window.location.pathname.match("/fr/")) {
  localStorage.setItem("i18nextLng", "fr");
  lang = "fr";
} else if (window.location.pathname.match("/it/")) {
  localStorage.setItem("i18nextLng", "it");
  lang = "it";
} else if (window.location.pathname.match("/pt/")) {
  localStorage.setItem("i18nextLng", "pt");
  lang = "pt";
} else if (window.location.pathname.match("/pl/")) {
  localStorage.setItem("i18nextLng", "pl");
  lang = "pl";
} else if (window.location.pathname.match("/ru/")) {
  localStorage.setItem("i18nextLng", "ru");
  lang = "ru";
} else if (window.location.pathname.match("/de/")) {
  localStorage.setItem("i18nextLng", "de");
  lang = "de";
} else if (window.location.pathname.match("/vi/")) {
  localStorage.setItem("i18nextLng", "vi");
  lang = "vi";
} else if (window.location.pathname.match("/zh/")) {
  localStorage.setItem("i18nextLng", "zh");
  lang = "zh";
} else if (window.location.pathname.match("/ph/")) {
  localStorage.setItem("i18nextLng", "ph");
  lang = "ph";
} else if (window.location.pathname.match("/tl/")) {
  localStorage.setItem("i18nextLng", "tl");
  lang = "tl";
} else if (window.location.pathname.match("/ja/")) {
  localStorage.setItem("i18nextLng", "ja");
  lang = "ja";
} else if (window.location.pathname.match("/nl/")) {
  localStorage.setItem("i18nextLng", "nl");
  lang = "nl";
} else if (window.location.pathname.match("/hi/")) {
  localStorage.setItem("i18nextLng", "hi");
  lang = "hi";
} else if (window.location.pathname.match("/tr/")) {
  localStorage.setItem("i18nextLng", "tr");
  lang = "tr";
} else if (window.location.pathname.match("/ar/")) {
  localStorage.setItem("i18nextLng", "ar");
  lang = "ar";
} else {
  localStorage.setItem("i18nextLng", "en");
}

export const fallbackLng = [lang];
export const availableLanguages = [
  "en",
  "es",
  "fr",
  "pt",
  "ar",
  "it",
  "pl",
  "ru",
  "de",
  "vi",
  "zh",
  "ph",
  "ja",
  "nl",
  "hi",
  "tr",
  "tl",
];

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  it: {
    translation: translationIT,
  },
  pt: {
    translation: translationPT,
  },
  ar: {
    translation: translationAR,
  },

  pl: {
    translation: translationPL,
  },
  ru: {
    translation: translationRU,
  },
  de: {
    translation: translationDE,
  },
  vi: {
    translation: translationVI,
  },
  zh: {
    translation: translationZH,
  },
  ph: {
    translation: translationPH,
  },
  tl: {
    translation: translationTL,
  },
  ja: {
    translation: translationJA,
  },
  nl: {
    translation: translationNL,
  },
  hi: {
    translation: translationHI,
  },
  tr: {
    translation: translationTR,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    detection: {
      checkWhitelist: true,
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
